import {FC} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'

type Props = {
  visible: boolean
  onClose: () => void
  onConfirm: () => void
}

const DeleteMainEngineReportModal: FC<Props> = ({visible, onClose, onConfirm}) => {
  if (!visible) return null

  return (
    <div className='modal-overlay' onClick={onClose}>
      <div className='modal-content' onClick={(e) => e.stopPropagation()} style={{maxWidth: '520px'}}>
        <div className='d-flex justify-content-end align-items-center'>
          <button className='close-btn' onClick={onClose}>
            <KTSVG path='/media/map/x.svg' className='svg-icon-2x' />
          </button>
        </div>
        <div className='custom-modal-body'>
          <div className='d-flex justify-content-center mb-4'>
            <KTSVG path='/media/map/exclamation.svg' className='svg-icon-4x' />
          </div>
          <p className='text-center mb-1'>Are you sure you want to delete this report?</p>
          <p className='text-center text-muted fs-7'>This action cannot be undone.</p>

          <div className='d-flex justify-content-center gap-2 mt-5'>
            <button type='button' className='btn btn_secondary' onClick={onClose}>No, Keep it</button>
            <button type='button' className='btn btn_danger' onClick={onConfirm}>Yes, Delete</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteMainEngineReportModal
